import Papa from 'papaparse';
import { forwardRef, useCallback, useImperativeHandle, useRef } from 'react';

export default forwardRef(function UploadCSV({ onChange }, ref) {
  const inputRef = useRef();
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    // Limpa o valor para permitir o reenvio do mesmo arquivo
    event.target.value = null;
    if (file && file.type === 'text/csv') {
      readCsv(file);
    }
  };
  const readCsv = (file) => {
    //Giovani ---- verificar não esta respeitando delimitador
    Papa.parse(file, {
      complete: (result) => {
        if (onChange && typeof onChange === 'function') {
          onChange(result.data);
        }
      },
      header: true,
      skipEmptyLines: true,
      delimitersToGuess: [',', ';'],
    });
  };
  useImperativeHandle(
    ref,
    useCallback(
      () => ({
        upload() {
          inputRef?.current?.click();
        },
      }),
      [inputRef]
    )
  );

  return (
    <input
      ref={inputRef}
      type="file"
      accept=".csv"
      style={{ display: 'none' }}
      onChange={handleFileUpload}
    />
  );
});
